<script>
    import { t } from "../i18n.js";
    import { push } from "svelte-spa-router";
    import BigInfoCard from "../components/BigInfoCard.svelte";
    import GuideSection from "../components/GuideSection.svelte";
    import UseDataIcon from "../assets/UseDataIcon.svelte";
    import BringDataIcon from "../assets/BringDataIcon.svelte";
    import { onMount } from "svelte";

    onMount(() => {
        window.scrollTo(0, 0);
    });

    const bigInfoCards = [
        {
            type: "use",
            desc: "dashboard.use-data-card-description",
            button: "dashboard.use-data-card-link",
            dest: "/interfaces",
        },
        {
            type: "bring",
            desc: "dashboard.bring-data-card-description",
            button: "dashboard.bring-data-card-link",
            dest: "/interfaces-import",
        },
    ];

    const smallCards = [
        {
            title: "dashboard.small-info-one",
            value: "3",
        },
        {
            title: "dashboard.small-info-two",
            value: "50",
        },
        {
            title: "dashboard.small-info-three",
            value: "2",
        },
    ];
</script>

<div>
    <div
        class="md:h-72 h-56 bg-center bg-no-repeat bg-cover bg-[url('/img/datajalostamo-hero-img-1.png')]"
    >
        <div class="h-full bg-black/25 flex items-center justify-center">
            <img
                src="img/datajalostamo-big-logo.png"
                alt={$t("general.datajalostamo-logo-alt")}
                class="w-96 md:w-3/5 max-w-5xl"
            />
        </div>
    </div>
    <div class="bg-light-navy">
        <div class="container py-12 text-center">
            <h1
                class="text-white font-bold mb-14 after:block after:absolute after:-inset-8 after:top-16 after:w-40 after:mx-auto after:bg-light-blue relative inline-block"
            >
                {$t("dashboard.page-title")}
            </h1>
            <p
                class="mx-8 md:mx-auto pb-16 text-white md:text-lg font-light max-w-2xl"
            >
                {$t("dashboard.page-description")}
            </p>
            <div
                class="grid grid-cols-1 md:grid-cols-2 md:gap-12 md:mx-auto mx-8 max-w-4xl"
            >
                {#each bigInfoCards as card}
                    <div class="mx-auto my-4 md:my-0 flex">
                        <BigInfoCard
                            description={$t(card.desc)}
                            button={$t(card.button)}
                            on:click={() => push(`${card.dest}`)}
                        >
                            <div slot="icon" class="flex justify-center mb-8">
                                {#if card.type === "use"}
                                    <UseDataIcon />
                                {:else}
                                    <BringDataIcon />
                                {/if}
                            </div>
                        </BigInfoCard>
                    </div>
                {/each}
            </div>
        </div>
    </div>
    <!-- <div class="bg-navy py-10"> -->
    <!-- <div class="container grid grid-cols-3 max-w-3xl">
            {#each smallCards as card}
                <div class="px-4 md:my-4 border-r-2 border-lightest-blue last:border-none">
                    <div class="text-white text-center">
                        <p class="font-semibold text-xl mb-1">
                            {card.value}
                        </p>
                        <p class="font-light text-xs md:text-sm text-white uppercase">
                            {$t(card.title)}
                        </p>
                    </div>
                </div>
            {/each}
        </div> -->
    <!-- </div> -->
    <div class="container py-10 px-8 md:px-0">
        <div class="mx-auto text-center">
            <img
                src="img/logos.png"
                alt={$t("general.datajalostamo-sponsors-alt")}
                class="md:mx-auto"
            />
        </div>
    </div>
    <GuideSection />
</div>
